import React, { useState } from "react";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";
import { CustomInputSelect } from "../../CustomInputSelect";
import { CustomInputArea } from "../../CustomInputArea";
import { CustomInputText } from "../../CustomInputText";
import { useChannels } from "../../../hooks/encuestas/useChannels";
import { useUsers } from "../../../hooks/useUsers";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";
import { useSedes } from "../../../hooks/useSedes";
import { Grid } from "@mui/material";
import { CustomInputSwitch } from "../../CustomInputSwitch";
import { SectionQuestions } from "./SectionQuestions";
import { SectionServices } from "./SectionServices";
import { useAreas } from "../../../hooks/useAreas";

export const UpdateSurveyForm = (props) => {

    const { data, action } = props;

    const [channel, setChannel] = useState(data?.canal?._id);
    const [activo, setActivo] = useState(data?.activo ? 'Activo' : 'Inactivo');
    const { handleSubmit, control, formState: { errors }, setValue } = useForm();
    const { channels } = useChannels();
    const { users } = useUsers();
    const { sedes } = useSedes();
    const { areas } = useAreas();

    const renderUserList = () => {

        return (
            <Controller 
                name='usuario'
                control={ control }
                defaultValue={ data?.usuario?._id || '' }
                render={({ field: { onChange, value } }) => (
                    <CustomInputSelect
                        label="Usuario"
                        options={ users.map(a => ({ ...a, name: convertirLetraMayus(a?.nombre, true) })) }
                        error={ errors?.usuario } 
                        onChange={ onChange }
                        value={ value }
                    />
                )}
                
                rules={{ 
                    required: 'El campo es obligatorio.',
                    pattern: {
                        value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                        message: "El usuario no es válido.",
                    }
                }}
            />
        )
    }

    return (
        <form style={{ position: 'relative',  width: 500 }} onSubmit={ handleSubmit(action) }>
            <div style={{ height: 600, overflowY: 'scroll', padding: 20 }}>
                <Controller 
                    name='titulo'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.titulo) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Nombre de encuesta"
                            placeholder=""
                            error={ errors?.titulo } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.'
                    }}
                />

                <Controller 
                    name='introduccion'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.introduccion) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputArea
                            label="Introducción"
                            placeholder=""
                            error={ errors?.introduccion } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.'
                    }}
                />

                <Controller 
                    name='codigo'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.codigo) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Código único"
                            placeholder=""
                            error={ errors?.codigo } 
                            onChange={ onChange }
                            value={ value }
                            disabled={ true }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.',
                        pattern: {
                            value: /^([a-zA-Z]{1}[0-9]{2})+[^\sa-zA-Z]$/,
                            message: "El código no es válido.",
                        }
                    }}
                />      

                <Grid container spacing={2} justifyContent='space-between'>
                    <Grid item xs={6}>
                        <Controller
                            name='canal'
                            control={ control }
                            defaultValue={ data?.canal?._id || '' }
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect
                                    label="Canal"
                                    options={channels.map(a => ({ ...a, name: a?.canal }))}
                                    error={ errors?.canal } 
                                    onChange={ (e) => {
                                        onChange(e);
                                        setChannel(e.target.value);
                                        !channels.filter(c => c?.interno !== 'Virtual').map(c => c?._id).includes(e.target.value) && setValue('usuario', null);
                                    }}
                                    value={ value }
                                />
                            )}
                            
                            rules={{ 
                                required: 'El campo es obligatorio.',
                                pattern: {
                                    value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                                    message: "El canal no es válido.",
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <Controller 
                            name='sede'
                            control={ control }
                            defaultValue={ data?.sede?._id || '' }
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect
                                    label="Sede"
                                    options={sedes.map(a => ({ ...a, name: a?.nombre }))}
                                    error={ errors?.sede } 
                                    onChange={ onChange }
                                    value={ value }
                                />
                            )}
                            
                            rules={{ 
                                required: 'El campo es obligatorio.',
                                pattern: {
                                    value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                                    message: "La sede no es válida.",
                                }
                            }}
                        />
                    </Grid>
                </Grid>

                <Controller
                    name='area'
                    control={ control }
                    defaultValue={ data?.area?._id || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputSelect
                            label="Area"
                            options={areas.map(a => ({ ...a, name: a?.nombre }))}
                            error={ errors?.area } 
                            onChange={ onChange }
                            value={ value }
                            placeholder='Seleccione un área'
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.',
                        pattern: {
                            value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                            message: "El área no es válida.",
                        }
                    }}
                />

                { channels.filter(c => c?.interno !== 'Virtual').map(c => c?._id).includes(channel) && renderUserList() }

                <Controller 
                    name='introduccion_servicios'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.introduccion_servicios) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputArea
                            label="Introducción servicios"
                            placeholder=""
                            error={ errors?.introduccion_servicios } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.',
                        pattern: {
                            value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                            message: "La composición de la pregunta no es válida.",
                        }
                    }}
                />

                <SectionServices label='Buscar servicios' data={ data?.servicios } setValue={ setValue } />
                <SectionQuestions label='Buscar preguntas' data={ data?.preguntas } setValue={ setValue } />

                <Controller 
                    name='activo'
                    control={ control }
                    defaultValue={ data?.activo || false }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputSwitch
                            label={ activo }
                            onChange={ (e) => {
                                onChange(e);
                                e.target.checked ? setActivo('Activo') : setActivo('Inactivo');
                            }}
                            value={ value }
                        />
                    )}
                />
            </div>

            <CustomButtonsForm name='Actualizar' style={{ position: 'sticky', bottom: 20, paddingRight: 20 }} />
        </form>
    );
};